// Test levels
export const TEST_LEVEL_VANGUARD = 'vanguard_only';
export const TEST_LEVEL_SF = 'salesforce_only';
export const TEST_LEVEL_ORION = 'orion_only';
export const TEST_LEVEL_FULL = 'TEST';

// Payment methods
export const PAYMENT_METHOD_SEPA = 'sepa';
export const PAYMENT_METHOD_BANK_CARD = 'bank_card';

// PaymentError
export const WAITING_PAGE_SUCCESS_STATUS_LOCALSTORAGE_KEY = 'waitingPageSuccessStatus';
export const WAITING_PAGE_ERROR_STATUS_LOCALSTORAGE_KEY = 'waitingPageErrorStatus';
export const WAITING_PAGE_ERROR_MESSAGE_LOCALSTORAGE_KEY = 'waitingPageErrorMessage';
// Ogone
export const VANGUARD_LOCALSTORAGE_KEY = 'paramPlus';

// Recurrences
export const RECURRENCE_X1 = 'x1';
export const RECURRENCE_X2 = 'x2';
export const RECURRENCE_X3 = 'x3';

// Product types
export const PRODUCT_TYPE_VIRTUAL = 'virtual';
export const PRODUCT_TYPE_PHYSICAL = 'physical';
// This ID represents a single product choice in Sales Force
export const RECORD_TYPE_ID_SINGLE_PRODUCT = '0120N000000sfyOQAQ';

// Display modes
export const DISPLAY_MODE_REGULAR = 'regular';
export const DISPLAY_MODE_COMBINED = 'combined';

// Order form types
export const ORDER_FORM_TYPE_REGULAR = 'direct';
export const ORDER_FORM_TYPE_1CLICK = '1click';
export const ORDER_FORM_TYPE_CHOICE_LIST = 'choice-list';
export const ORDER_FORM_TYPE_CHOICE_LIST_1CLICK = 'choice-list-1click';

// Order steps
export const ORDER_STEP_INITIAL = 'initial';
export const ORDER_STEP_1CLICK = '1click';
export const ORDER_STEP_CROSS_SELL = 'crosssell';
export const ORDER_STEP_UP_SELL = 'upsell';
export const ORDER_STEP_CANCEL = 'cancel';

// Order status
export const ORDER_STATUS_PENDING = 'pending';
export const ORDER_STATUS_COMPLETED = 'completed';
export const ORDER_STATUS_WAITING_FOR_PAYMENT = 'waitingForPayment';
export const ORDER_STATUS_CANCELLED = 'cancelled';
export const ORDER_STATUS_ALREADY = 'already';

// App type
export const APP_TYPE_DEFAULT = 'default';
export const APP_TYPE_MULTIPLE = 'multiple';

// LocalStorage
export const PREVIOUS_CHOICE = 'PREVIOUS_CHOICE';
export const LOCALSTORAGE_ORDERS_JOURNEY = 'ordersJourney';
export const LOCAL_STORAGE_CUSTOMER_HEMAIL = 'customerHEmail';

// Cookies
export const COOKIE_PREVIOUS_ORDER = 'PREVIOUS_ORDER_ID';
export const COOKIE_HAS_1_CLICK_OPT_OUT = 'HAS1_CLICK_OPT_OUT';

export const SEPA_MANDATES_SIGNATURE = 'sepaMandatesSignature';



// WEBPACK FOOTER //
// ./src/common/constants.js